import { useCustomerShowApi, useCustomerStore } from '@entities/customer'
import { useCommonStore } from '@shared/model'

import { useCustomerDetailsApi } from '../api/details.hook'

interface CustomerRefreshReturn {
  runWithPageLoader: (flow: () => Promise<void>) => Promise<void>
  refreshCustomer: (customerId: number) => Promise<void>
}

/**
 * A write followed by a reread is one flow for the admin: the page loader goes up when it starts and down
 * when it ends or any request in it fails. The details reread only keeps the buttons busy; the customer
 * reread is shared with other pages and drives the page loader itself, so it runs last, when dropping the
 * loader is what the flow does anyway.
 */
export const useCustomerRefresh = (): CustomerRefreshReturn => {
  const commonStore = useCommonStore()
  const customerStore = useCustomerStore()

  const runWithPageLoader = async (flow: () => Promise<void>): Promise<void> => {
    commonStore.setLoading(true)

    try {
      await flow()
    } finally {
      commonStore.setLoading(false)
    }
  }

  const refreshCustomer = async (customerId: number): Promise<void> => {
    await useCustomerDetailsApi({ customerId, onLoadingChange: customerStore.trackProcessing })
    await useCustomerShowApi({ customerId })
  }

  return {
    runWithPageLoader,
    refreshCustomer,
  }
}
